import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const SpcificPageModal = ({ specificModal, setSpecificModal }) => {
    const [formData, setFormData] = useState({
        email: "",
        city: "",
        travelerType: "",
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const blockedDomains = [
        "yopmail.com",
        "mailinator.com",
        "tempmail.com",
        "temporary-mail.net",
        "temp-mail.org",
        "10minutemail.com",
        "guerrillamail.com",
        "trashmail.com",
        "fakeinbox.com",
        "getnada.com",
        "dispostable.com",
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((p) => ({ ...p, [name]: value }));
        setErrors((p) => ({ ...p, [name]: "" }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        const emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!formData.email) {
            newErrors.email = "Email is required";
            isValid = false;
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = "Enter a valid email";
            isValid = false;
        } else {
            const domain = formData.email.split("@")[1]?.toLowerCase();
            if (blockedDomains.includes(domain)) {
                newErrors.email = "Disposable emails not allowed";
                isValid = false;
            }
        }

        if (!formData.city) {
            newErrors.city = "City is required";
            isValid = false;
        }

        if (!formData.travelerType) {
            newErrors.travelerType = "Travel preference is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        const { email, city, travelerType } = formData;

        const url = `https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(
            email
        )}&firstName=${encodeURIComponent(
            email.split("@")[0]
        )}&city=${encodeURIComponent(
            city
        )}&travelerType=${encodeURIComponent(travelerType)}`;

        try {
            const res = await fetch(url);
            const data = await res.json();

            if (res.ok) {
                toast.success(data.message || "Subscribed successfully");
                setFormData({ email: "", city: "", travelerType: "" });
                setSpecificModal(false);
            } else {
                toast.error("Submission failed");
            }
        } catch (err) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={specificModal}
            onHide={() => setSpecificModal(false)}
            centered
            size="xl"
            backdrop="static"
            className="plan-marte-bg"
        >
            <Modal.Body>
                <button
                    className="btn-close plan_smarter_close"
                    onClick={() => setSpecificModal(false)}
                />

                <div className="plan_smarter">
                    <div className="row">
                        <div className="col-lg-6 d-none d-lg-block">
                            {/* Left image / banner if needed */}
                        </div>

                        <div className="col-lg-6">
                            <div className="Plan_smarter_right">
                                <h2>Plan a Smarter Trip—Free Welcome Gift 🎁</h2>
                                <p>
                                    Get our free travel guide with personalized trip ideas + money-saving tips.
                                </p>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Enter Your Email"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <div className="text-danger small">{errors.email}</div>
                                        )}
                                    </div>

                                    <div className="form-group mb-3">
                                        <input
                                            type="text"
                                            name="city"
                                            placeholder="Your Home City"
                                            className="form-control"
                                            value={formData.city}
                                            onChange={handleChange}
                                        />
                                        {errors.city && (
                                            <div className="text-danger small">{errors.city}</div>
                                        )}
                                    </div>
                                    <div className="form-group mb-4">
                                        <select
                                            name="travelerType"
                                            className="form-control"
                                            value={formData.travelerType}
                                            onChange={handleChange}
                                        >
                                            <option value="">What kind of travel do you like</option>
                                            <option value="Solo">Solo</option>
                                            <option value="Couple">Couple</option>
                                            <option value="Family">Family</option>
                                            <option value="Friends">Friends</option>
                                        </select>

                                        {errors.travelerType && (
                                            <div className="text-danger small">
                                                {errors.travelerType}
                                            </div>
                                        )}
                                    </div>


                                    <button
                                        type="submit"
                                        className="submit-btn"
                                        disabled={loading}
                                    >
                                        {loading ? "Submitting..." : "Explore"}
                                    </button>
                                </form>

                                <p className="mt-3">
                                    5k+ of travellers have scored our free guide.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SpcificPageModal;
